export default function ({ $auth, $gates }) {
  // set gates roles
  if ($auth.user) {
    $gates.setRoles($auth.user.roles)
  }
}
